module.exports = __webpack_public_path__ + "static/elephantstarhamper-d217b35188e5f1273725088cc7475143.jpeg";